var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapContainer"},[(_vm.config.mapType === 'canvas')?_c('canvas'):_c('div',{attrs:{"id":"chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }